import { Reveal, SectionLabel, LuxBg } from "../Reveal";
import { Accordion } from "../Accordion";
import { FAQS } from "../../content";

export const Faq = () => (
  <section id="faq" className="relative py-28 md:py-36 px-6 sm:px-10 lg:px-16 xl:px-24" data-testid="faq-section">
    <LuxBg n={3} />
    <div className="max-w-4xl">
      <Reveal><SectionLabel num="008" text="STILL DECIDING?" /></Reveal>
      <Reveal delay={0.05}>
        <h2 className="serif font-black uppercase tracking-tight text-3xl md:text-5xl text-white mb-12">
          COMMON <span className="text-[#FE0000]">QUESTIONS</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion prefix="faq" items={FAQS.map((f) => ({ title: f.q, body: f.a }))} />
      </Reveal>
    </div>
  </section>
);
